// The storefront opens the widget with a short-lived Loyalify session token in the URL fragment
// (#session=...). Loyalify issued it from a Shopify-signed app proxy request, and checks it on every
// API call. The widget only reads the shop and customer inside it to decide what to show.
let token = "";
let claims = {};

function decodeClaims(value) {
  try {
    const payload = value.split(".")[0].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(payload.padEnd(payload.length + ((4 - (payload.length % 4)) % 4), "=")));
  } catch (error) {
    return {};
  }
}

export function loadSession() {
  const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  token = params.get("session") || "";
  claims = token ? decodeClaims(token) : {};
  if (token) {
    // Keep the token out of the address bar and browser history.
    window.history.replaceState(null, "", window.location.pathname + window.location.search);
  }
}

export const getSessionToken = () => token;
export const getSessionCustomerId = () => claims.c || undefined;
export const getSessionShopDomain = () => claims.s || undefined;
